import React, {useEffect, useMemo , useState} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, setShowPopUp, pushToHistory} from './BusinessWorkOrderSystemSlice';
import {getContactCompanyList, setSelectedHetPay} from '../PortalsBlock/portalSlice';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {BusinessWorkOrderSystemStep} from './Constant/Constant';
import EpiContext from '@episerver/spa-core/Spa';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import GeneralMessage from './Steps/GeneralMessage';
import WorkOrderDashboard from './Steps/WorkOrderDashboard';
import WorkOrderTypeSelecting from './Steps/WorkOrderTypeSelecting';
import WorkOrderForm from './Steps/WorkOrderForm/WorkOrderForm';
import SelectCompany from 'app/Components/Shared/SelectBusinessCompany/SelectCompany';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import BusinessWOMainPopup from './Popup/BusinessWOMainPopup';
import Config from 'app/Config';
import WorkOrderConfirmation from './Steps/WorkOrderConfirmation';
import WorkOrderCreationSuccedded from './Steps/WorkOrderCreationSuccedded';
import ReopenWorkOrder from './Steps/ReopenWorkOrder';
const BusinessWorkOrderSystemMain = ({
  context,
  contentData,
  businessWorkOrderSystem,
  authentication,
  portalsBlock,
  setCurrentStep,
  showAppLoader,
  hideAppLoader,
  getContactCompanyList,
  setSelectedHetPay,
  setShowPopUp,
  pushToHistory,
}) => {
  useEffect(() => {
    if (authentication.isAuthenticateFinish) {
      start();
    }
    //  else {
    //    showAppLoader();
    //  }
  }, [authentication]);

  function start() {
    if (portalsBlock.hetPaysNumbers.length == 0 && !portalsBlock.requestCompleted) {
      loadCompanies();
    } else {
      setCurrentStep(BusinessWorkOrderSystemStep.Dashboard);
    }
  }

  async function loadCompanies() {
    showAppLoader();
    await getContactCompanyList().then((res) => {
      setCurrentStep(BusinessWorkOrderSystemStep.SelectCompany);
    });
    hideAppLoader();
  }

  const generalMessageActions = {
    businessLobby: () => EpiContext.navigateTo(Config.businessLobby),
    setCurrentStep: () => setCurrentStep(),
  };

  const currentStep = useMemo(() => {
    window.scrollTo(0, 0);

    var currentPath = window.location.href.split('#')[1];
    if (businessWorkOrderSystem.currentStep !== currentPath) {
      const isInitialNavigation = !currentPath;
      if (isInitialNavigation) {
        const hash = `#${businessWorkOrderSystem.currentStep}`;
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', hash);
        }
      } else {
        pushToHistory(businessWorkOrderSystem.currentStep);
      }
    }
    switch (businessWorkOrderSystem.currentStep) {
      case BusinessWorkOrderSystemStep.SelectCompany:
        return (
          <div className=''>
            <SelectCompany setNextStep={() => setCurrentStep(BusinessWorkOrderSystemStep.Dashboard)} title='ניהול פניות' />
          </div>
        );
      case BusinessWorkOrderSystemStep.Dashboard:
        return <WorkOrderDashboard />;
      case BusinessWorkOrderSystemStep.WorkOrderTypeSelecting:
        return <WorkOrderTypeSelecting />;
      case BusinessWorkOrderSystemStep.WorkOrderForm:
        return <WorkOrderForm contentData={contentData} />;
      case BusinessWorkOrderSystemStep.WorkOrderConfirmation:
        return <WorkOrderConfirmation />;
      case BusinessWorkOrderSystemStep.WorkOrderCreationSuccedded:
        return <WorkOrderCreationSuccedded />;
      case BusinessWorkOrderSystemStep.ReopenWorkOrder:
        return <ReopenWorkOrder />;
      case BusinessWorkOrderSystemStep.GeneralMessage:
        return (
          <GeneralMessage
            messageData={businessWorkOrderSystem.generalMessage}
            buttonClick={generalMessageActions[businessWorkOrderSystem.generalMessage?.buttonClick]}
            secondButtonClick={generalMessageActions[businessWorkOrderSystem.generalMessage?.secondButtonClick]}
          />
        );

      default:
        break;
    }
  }, [businessWorkOrderSystem.currentStep]);

  return (
    <div className='business-work-order-system'>
      {currentStep}
      <PopUp
        className={`${businessWorkOrderSystem.currentPopUp} mainPopup`}
        showPopUp={businessWorkOrderSystem.showPopup}
        onClose={() => setShowPopUp(false)}>
        <BusinessWOMainPopup />
      </PopUp>
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
});
const mapDispatchToProps = {
  setCurrentStep,
  getContactCompanyList,
  setSelectedHetPay,
  showAppLoader,
  hideAppLoader,
  setShowPopUp,
  pushToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessWorkOrderSystemMain);
